import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PoModalModule, PoPageModule, PoWidgetModule, PoFieldModule, PoButtonModule, PoContainerModule, PoLoadingModule, PoModalAction, PoModalComponent, PoNotificationService } from '@po-ui/ng-components';
import { ApiService } from '../shared/service/api.service';
import { TokenService } from '../shared/service/token.service';
import { UserTerminalService } from '../shared/service/user-terminal.service';
import { CountService } from '../shared/service/count.service';

@Component({
  selector: 'app-modal-terminal-select',
  imports:
    [FormsModule,
      PoModalModule,
      PoPageModule,
      PoWidgetModule,
      PoFieldModule,
      PoButtonModule,
      PoContainerModule,
      CommonModule,
      PoLoadingModule],
  templateUrl: './modal-terminal-select.component.html',
  styleUrl: './modal-terminal-select.component.css'
})
export class ModalTerminalSelectComponent {
  @ViewChild('modal', { static: false }) private modal!: PoModalComponent;
  @Output() selected = new EventEmitter<string>();
  @Output() cancel = new EventEmitter();
  terminalList: any = [{ label: 'default', value: '0' }];
  terminalSelected: string = '';
  size = 'sm';
  text = 'Carregando';
  isLoading: boolean = false;
  removeInitialFilter = true;
  primaryActionTerminal: PoModalAction = {
    action: () => {
      if (!isNaN(Number(this.terminalSelected))) {
        this.confirm();
      }
    },
    label: 'Confirmar'
  };
  secondaryActionTerminal: PoModalAction = {
    action: () => {
      this.modal.close();
      this.exit();
    },
    label: 'Sair'
  };

  constructor(
    private tokenService: TokenService,
    private countService: CountService,
    private poNotification: PoNotificationService,
    private userTerminalService: UserTerminalService
  ) { }

  async open() {
    var shouldOpen = await this.recoverTerminalList();
    if (shouldOpen) {
      this.modal.open();
      return;
    }

    this.selected.emit(this.terminalSelected);
    return;
  }

  private recoverTerminalList(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.tokenService.getTokenV2() == null) {
        return resolve(false);
      }

      this.isLoading = true;
      this.countService.getTerminalList(parseInt(this.tokenService.getBranch() ?? '0'))
        .subscribe({
          next: (data: any) => {
            this.terminalList = [];
            data.terminalUsers.map((item: any) => {
              this.terminalList.push({ label: item.terminalDescription, value: item.terminalCode })
            });
          },
          error: () => {
            this.poNotification.warning("Não foi possível obter os terminais para o usuário.");
            this.isLoading = false;
            return resolve(false);
          },
          complete: () => {
            this.isLoading = false;

            if (this.terminalList.length == 0) {
              this.poNotification.warning("Não há terminais liberados para este usuário.");
              this.exit();
              this.modal.close();
              return resolve(false);
            }

            const userName = this.tokenService.getUsername();

            if (this.terminalList.length == 1) {
              var terminal = this.terminalList[0];

              this.poNotification.warning(`Apenas o terminal '${terminal.value} - ${terminal.label}' está disponível para o usuário.`);

              this.terminalSelected = String(terminal.value);

              this.userTerminalService.addOrUpdateItem({ UserName: userName!, TerminalCode: terminal.value });
              return resolve(false);
            }

            var userTerminal = this.userTerminalService.getByUsername(userName!);

            if (userTerminal != null && this.terminalList.find((x: { label: string, value: number; }) => x.value == userTerminal!.TerminalCode)) {
              this.setTerminal(String(userTerminal.TerminalCode));
            }

            return resolve(true);
          }
        });
    });
  }

  protected setTerminal(event: any) {
    if (event == undefined)
      return;

    this.terminalSelected = event;
  }

  confirm() {
    const userName = this.tokenService.getUsername();

    this.userTerminalService.addOrUpdateItem({ UserName: userName!, TerminalCode: Number(this.terminalSelected) });
    this.selected.emit(this.terminalSelected);
    this.poNotification.success('Alterado com sucesso.');
    this.modal.close();
  }

  exit() {
    this.cancel.emit();
  }
}


